let filtersOpened = false;
let mobileFiltersOpened = false; // Track mobile filter state
let isListView = false; // false = grid, true = list (1-col)
let viewAsLabel = document.querySelector('.js--change-view');
let showFiltersButton = document.querySelector('.show-filters');
document.addEventListener('DOMContentLoaded', () => {
  const facetWrapper = document.getElementById('main-collection-filters');
  const showFiltersButton = document.querySelector('.show-filters');
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  
  // Samo za desktop - ne dodavaj event listener na mobilnim uređajima
  if (!mediaQuery.matches) {
    facetWrapper.style.display = 'none';
    showFiltersButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(`Activated filters button`);
      showFiltersButton.innerHTML = 'Hide Filters';
    const productGridEl = document.getElementById('product-grid');
    if (!productGridEl) return;
    console.log(productGridEl.classList);
    if (showFiltersButton.classList.contains('opened_filters')) {
      console.log(`Filters are closed`);
      showFiltersButton.innerHTML = 'Show Filters';
      filtersOpened = false;
      facetWrapper.style.display = 'none';
      showFiltersButton.classList.remove('opened_filters');
      if(isListView) {
        console.log(`Izasao sam iz list view`);
      }
      if (!isListView) {
        console.log(`Izasao sam iz grid view`);
        Array.from(productGridEl.classList)
          .filter((c) => /grid--\d-col-desktop/.test(c))
          .forEach((c) => productGridEl.classList.remove(c));
        productGridEl.classList.add('grid--4-col-desktop');
        try { FacetFiltersForm.persistDesktopClass = 'grid--4-col-desktop'; } catch (e) {}
      }
    } else {
      showFiltersButton.innerHTML = 'Hide Filters';
      console.log(`Filters are opened`);
      filtersOpened = true;
      facetWrapper.style.display = 'block';
      showFiltersButton.classList.add('opened_filters');
      if (!isListView) {
        Array.from(productGridEl.classList)
          .filter((c) => /grid--\d-col-desktop/.test(c))
          .forEach((c) => productGridEl.classList.remove(c));
        productGridEl.classList.add('grid--3-col-desktop');
        try { FacetFiltersForm.persistDesktopClass = 'grid--3-col-desktop'; } catch (e) {}
      }
    }
    });
  }
});

// Event delegation so handlers survive re-rendering
document.addEventListener('click', (e) => {
  const gridEl = document.getElementById('product-grid');
  if (!gridEl) return;

  const gridBtn = e.target.closest('.show-grid');
  const listBtn = e.target.closest('.show-list');
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  if (gridBtn) {
    e.preventDefault();
    // switch to grid view
    isListView = false;
    
    if (mediaQuery.matches) {
      // Mobile: adjust columns based on filter state
      Array.from(gridEl.classList)
        .filter((c) => /grid--\d-col/.test(c))
        .forEach((c) => gridEl.classList.remove(c));
      // When mobile filters are open, use 1 column, otherwise 2 columns
      const target = mobileFiltersOpened ? 'grid--1-col-tablet-down' : 'grid--2-col-tablet-down';
      gridEl.classList.add(target);
      try { FacetFiltersForm.persistMobileClass = target; } catch (e) {}
    } else {
      // Desktop: existing logic
      Array.from(gridEl.classList)
        .filter((c) => /grid--\d-col-desktop/.test(c))
        .forEach((c) => gridEl.classList.remove(c));
      const target = filtersOpened ? 'grid--3-col-desktop' : 'grid--4-col-desktop';
      gridEl.classList.add(target);
      try { FacetFiltersForm.persistDesktopClass = target; } catch (e) {}
    }
    
    if (viewAsLabel) viewAsLabel.textContent = 'Grid Selected:';
  }

  if (listBtn) {
    e.preventDefault();
    // switch to list view (1 column)
    isListView = true;
    
    if (mediaQuery.matches) {
      // Mobile: 1 column for list view
      Array.from(gridEl.classList)
        .filter((c) => /grid--\d-col/.test(c))
        .forEach((c) => gridEl.classList.remove(c));
      gridEl.classList.add('grid--1-col-tablet-down');
      try { FacetFiltersForm.persistMobileClass = 'grid--1-col-tablet-down'; } catch (e) {}
    } else {
      // Desktop: existing logic
      Array.from(gridEl.classList)
        .filter((c) => /grid--\d-col-desktop/.test(c))
        .forEach((c) => gridEl.classList.remove(c));
      gridEl.classList.add('grid--1-col-desktop');
      try { FacetFiltersForm.persistDesktopClass = 'grid--1-col-desktop'; } catch (e) {}
    }
    
    if (viewAsLabel) viewAsLabel.textContent = 'List Selected:';
  }
});

document.addEventListener('DOMContentLoaded', () => {
  let mediaQuery = window.matchMedia('(max-width: 749px)');
  let body = document.body;
  
  // Sakrij filtere na početku na mobilnim uređajima
  if(mediaQuery.matches) {
    let mobileFacets = document.querySelector('.facets-container');
    if(mobileFacets) {
      mobileFacets.style.display = 'none';
      mobileFacets.style.visibility = 'hidden';
    }
  }
  
  body.addEventListener('click', (e) => {
    let mobileFacets = document.querySelector('.facets-container');
    let showButton = document.querySelector('.js--show-mobile-drawer');
    
    if(mediaQuery.matches && mobileFacets) {
      // Ako je klik na Show Filters button - otvori drawer
      if(e.target.closest('.js--show-mobile-drawer')) {
        e.preventDefault();
        mobileFacets.style.display = 'block';
        mobileFacets.style.visibility = 'visible';
        document.body.style.overflow = 'hidden';
        mobileFiltersOpened = true; // Set mobile filters as opened
        
        // Promeni tekst button-a na "Hide Filters"
        if(showButton) {
          showButton.textContent = 'Hide Filters';
          showButton.innerHTML = 'Hide Filters';
        }
      }
      // Ako je klik VAN facets-container i VAN show button - zatvori drawer
      else if(!e.target.closest('.facets-container') && 
              !e.target.closest('.js--show-mobile-drawer')) {
        mobileFacets.style.display = 'none';
        mobileFacets.style.visibility = 'hidden';
        document.body.style.overflow = '';
        mobileFiltersOpened = false; // Set mobile filters as closed
        
        // Vrati tekst button-a na "Show Filters"
        if(showButton) {
          showButton.textContent = 'Show Filters';
          showButton.innerHTML = 'Show Filters';
        }
      }
    }
  });
});



class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // console.log(showFiltersButton, showGridButton, showListButton);
  }

  static setListeners() {

    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {

    FacetFiltersForm.searchParamsPrev = searchParams;
    // Capture current grid class to persist after re-render (both desktop and mobile)
    try {
      const currentGrid = document.getElementById('product-grid');
      const mediaQuery = window.matchMedia('(max-width: 749px)');
      
      if (currentGrid) {
        if (mediaQuery.matches) {
          // Capture mobile grid class
          const mobileClass = Array.from(currentGrid.classList).find((c) => /grid--\d-col-tablet-down/.test(c));
          FacetFiltersForm.persistMobileClass = mobileClass || null;
          console.log('Capturing mobile class before re-render:', mobileClass);
          console.log('Current grid classes:', Array.from(currentGrid.classList));
        } else {
          // Capture desktop grid class
          const desktopClass = Array.from(currentGrid.classList).find((c) => /grid--\d-col-desktop/.test(c));
          FacetFiltersForm.persistDesktopClass = desktopClass || null;
        }
      }
    } catch (e) {
      if (window.matchMedia('(max-width: 749px)').matches) {
        FacetFiltersForm.persistMobileClass = null;
      } else {
        FacetFiltersForm.persistDesktopClass = null;
      }
    }
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Persist grid layout (grid or list) across re-render for both desktop and mobile
    try {
      const gridEl = document.getElementById('product-grid');
      const mediaQuery = window.matchMedia('(max-width: 749px)');
      
      if (gridEl) {
        if (mediaQuery.matches) {
          // Mobile: persist mobile grid classes
          console.log('renderProductGridContainer - Mobile persistMobileClass:', FacetFiltersForm.persistMobileClass);
          if (FacetFiltersForm.persistMobileClass) {
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(FacetFiltersForm.persistMobileClass);
            console.log('renderProductGridContainer - Applied persisted mobile class:', FacetFiltersForm.persistMobileClass);
          } else {
            // Fallback to current runtime state for mobile
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            if (isListView) {
              gridEl.classList.add('grid--1-col-tablet-down');
              console.log('renderProductGridContainer - Applied fallback list view');
            } else {
              const target = mobileFiltersOpened ? 'grid--1-col-tablet-down' : 'grid--2-col-tablet-down';
              gridEl.classList.add(target);
              console.log('renderProductGridContainer - Applied fallback grid view:', target);
            }
          }
        } else {
          // Desktop: existing logic
          if (FacetFiltersForm.persistDesktopClass) {
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col-desktop/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(FacetFiltersForm.persistDesktopClass);
          } else {
            // If for any reason persistDesktopClass is not set, fallback to current runtime state
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col-desktop/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(isListView ? 'grid--1-col-desktop' : filtersOpened ? 'grid--3-col-desktop' : 'grid--4-col-desktop');
          }
        }
      }
    } catch (e) {}
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    console.log(`filtersLaunched`);
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // After filters re-render, persist grid/list layout for both desktop and mobile
    try {
      const gridEl = document.getElementById('product-grid');
      const mediaQuery = window.matchMedia('(max-width: 749px)');
      
      if (gridEl) {
        if (mediaQuery.matches) {
          // Mobile: persist mobile grid classes
          console.log('Mobile re-render - persistMobileClass:', FacetFiltersForm.persistMobileClass);
          console.log('Mobile re-render - isListView:', isListView);
          console.log('Mobile re-render - mobileFiltersOpened:', mobileFiltersOpened);
          
          if (FacetFiltersForm.persistMobileClass) {
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(FacetFiltersForm.persistMobileClass);
            console.log('Applied persisted mobile class:', FacetFiltersForm.persistMobileClass);
          } else {
            // Default mobile layout based on current state
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            if (isListView) {
              gridEl.classList.add('grid--1-col-tablet-down');
              console.log('Applied list view: grid--1-col-tablet-down');
            } else {
              const target = mobileFiltersOpened ? 'grid--1-col-tablet-down' : 'grid--2-col-tablet-down';
              gridEl.classList.add(target);
              console.log('Applied grid view:', target);
            }
          }
        } else {
          // Desktop: existing logic
          if (FacetFiltersForm.persistDesktopClass) {
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col-desktop/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(FacetFiltersForm.persistDesktopClass);
          } else {
            Array.from(gridEl.classList)
              .filter((c) => /grid--\d-col-desktop/.test(c))
              .forEach((c) => gridEl.classList.remove(c));
            gridEl.classList.add(isListView ? 'grid--1-col-desktop' : filtersOpened ? 'grid--3-col-desktop' : 'grid--4-col-desktop');
          }
        }
      }
    } catch (e) {}

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.textInputs = this.querySelectorAll('.price-range-inputs input');
    this.sliderMin = this.querySelector('.price-range__input--min');
    this.sliderMax = this.querySelector('.price-range__input--max');
    this.progress = this.querySelector('.price-range__progress');
    this.track = this.querySelector('.price-range__track');
    this.bubbleMin = this.querySelector('.price-range__bubble--min');
    this.bubbleMax = this.querySelector('.price-range__bubble--max');

    // Fallback for themes without the new UI
    const plainInputs = this.querySelectorAll('input');
    if (!this.sliderMin || !this.sliderMax) {
      plainInputs.forEach((element) => {
        element.addEventListener('change', this.onRangeChange.bind(this));
        element.addEventListener('keydown', this.onKeyDown.bind(this));
      });
      this.setMinAndMaxValues();
      return;
    }

    // Initialize
    this.max = Number(this.sliderMin.getAttribute('max')) || 0;
    this.currencySymbol = this.closest('.price-range-ui')?.dataset?.currencySymbol || '';

    // Sync from sliders to hidden text inputs and UI
    this.sliderMin.addEventListener('input', () => this.onSliderInput('min'));
    this.sliderMax.addEventListener('input', () => this.onSliderInput('max'));
    this.sliderMin.addEventListener('change', () => this.onSliderCommit());
    this.sliderMax.addEventListener('change', () => this.onSliderCommit());

    // Ensure ordering and constraints
    this.coerceOrder();
    this.updateProgress();
    this.updateBubbles();
    this.syncTextInputs();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  // New UI helpers
  onSliderInput(which) {
    this.coerceOrder(which);
    this.updateProgress();
    this.updateBubbles();
    this.syncTextInputs();
  }

  onSliderCommit() {
    // Trigger form submission via facets debounced handler
    const form = this.closest('form');
    if (!form) return;
    const event = new Event('input', { bubbles: true });
    form.dispatchEvent(event);
  }

  coerceOrder(changed) {
    const min = Number(this.sliderMin.value);
    const max = Number(this.sliderMax.value);

    if (min > max) {
      if (changed === 'min') {
        this.sliderMax.value = min;
      } else if (changed === 'max') {
        this.sliderMin.value = max;
      } else {
        const avg = Math.round((min + max) / 2);
        this.sliderMin.value = Math.min(avg, this.sliderMin.max);
        this.sliderMax.value = Math.max(avg, this.sliderMax.min);
      }
    }
  }

  updateProgress() {
    const host = this.closest('.price-range-ui') || this.parentElement;
    const min = Number(this.sliderMin.value);
    const max = Number(this.sliderMax.value);
    const percentMin = (min / this.max) * 100;
    const percentMax = (max / this.max) * 100;
    const left = Math.max(0, Math.min(100, percentMin));
    const right = Math.max(0, Math.min(100, percentMax));
    this.style.setProperty('--min-p', `${left}%`);
    this.style.setProperty('--max-p', `${right}%`);
    if (host && host.style) {
      host.style.setProperty('--min-p', `${left}%`);
      host.style.setProperty('--max-p', `${right}%`);
    }
  }

  formatMoney(value) {
    // Use theme money formatting if available in window, else basic format
    try {
      const number = Number(value) || 0;
      return `${this.currencySymbol}${number.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}.00`;
    } catch (e) {
      return `${this.currencySymbol}${value}`;
    }
  }

  updateBubbles() {
    if (!this.bubbleMin || !this.bubbleMax) return;
    this.bubbleMin.textContent = this.formatMoney(this.sliderMin.value);
    this.bubbleMax.textContent = this.formatMoney(this.sliderMax.value);
  }

  syncTextInputs() {
    if (!this.textInputs || this.textInputs.length < 2) return;
    const minInput = this.textInputs[0];
    const maxInput = this.textInputs[1];
    minInput.value = this.sliderMin.value;
    maxInput.value = this.sliderMax.value;

    // keep data-* in sync for legacy validation
    minInput.setAttribute('data-max', this.sliderMax.value);
    maxInput.setAttribute('data-min', this.sliderMin.value);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


